import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettlementService = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.72277 14.7822V18.9703C7.72277 19.5116 8.16162 19.9505 8.70297 19.9505H15.0743H20.0198C20.5611 19.9505 21 19.5116 21 18.9703L21 10.391C21 9.79804 20.6898 9.24829 20.1822 8.94174L12.7832 4.473C12.3016 4.18213 11.6984 4.18213 11.2168 4.473L3.81777 8.94174C3.31021 9.24829 3 9.79804 3 10.391V19.9505",
			stroke: "currentColor",
			strokeWidth: 1.42574,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.72277 14.7822V18.9703C7.72277 19.5116 8.16162 19.9505 8.70297 19.9505H15.0743H20.0198C20.5611 19.9505 21 19.5116 21 18.9703L21 10.391C21 9.79804 20.6898 9.24829 20.1822 8.94174L12.7832 4.473C12.3016 4.18213 11.6984 4.18213 11.2168 4.473L3.81777 8.94174C3.31021 9.24829 3 9.79804 3 10.391V19.9505",
			stroke: "currentColor",
			strokeWidth: 1.42574,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.2578 4.26721L17.2578 6.85137",
			stroke: "currentColor",
			strokeWidth: 1.42574,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4 10.9V13.3M14.4 13.3V15.7M14.4 13.3H16.8M14.4 13.3H12",
			stroke: "currentColor",
			strokeWidth: 1.56,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSettlementService;
